import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router';
import { hamburgerRoutes, hasUserGrantedPOA } from '../../utils/global_functions';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal } from '../../redux/actions/modals';
import { FACILITY_NUM, LOCAL_STORAGE_KEYS } from '../../utils/global_variables';
import { closeHamburgerMenu } from '../../redux/actions/appInfo';

const DashMenu = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { pathname } = useLocation();

    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - Start
    const { hamburgerMenu: objHamburgerMenu = {} } = useSelector(state => state.appInfo.dynamicMenus);
    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - End
    const objCFT = useSelector(state => state.auth.objCFT);
    // Ajitesh: 26/02/2024: BT-122859: Breeze pledge implementation - Start
    // Ajitesh: 26/02/2024: BT-122859: Breeze pledge implementation - End    
    // Ajitesh : 01/12/2023: BT-109135: Breeze eDIS implementation - Start
    const isEdisMenuVisible = hasUserGrantedPOA();
    // Ajitesh : 01/12/2023: BT-109135: Breeze eDIS implementation - End




    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - Start
    const arrDashMenu = useMemo(() => {
        const arrMenus = [];
        if (objHamburgerMenu?.items?.length > 0) {
            objHamburgerMenu.items.forEach(objMenu => {
                if ((objMenu.id === 404 || objMenu.id === 304) && !objMenu?.childs.length && !objMenu?.menuUrl) {
                    return
                }
                if (objMenu?.name === "edis" && objMenu.id === 307) {
                    if (isEdisMenuVisible) return;
                }
                if (objMenu?.name === "pledge" && objMenu?.id === 309 && objCFT.PLEDGEUNPLEDGE === FACILITY_NUM.OFF) {
                    return;
                }
                if (objMenu?.name === 'recommendations & alerts') {
                    if (objCFT.ALERT === FACILITY_NUM.ON) {
                        arrMenus.push({ id: objMenu?.id, name: objMenu?.displayName, icon: <div className={`icon-20 ${objMenu?.iconUrl} hamburger-menu-iconcolor flex-shrink-0`}></div>, route: objMenu?.menuUrl, guestMode: objMenu?.guestMode, sequenceNo: objMenu?.sequenceNo });
                    } else { }
                } else {
                    if (objMenu?.name === "order cart" && objCFT.BULKORDER === FACILITY_NUM.OFF) {
                        return;
                    } else {
                        arrMenus.push({ id: objMenu?.id, name: objMenu?.displayName, icon: <div className={`icon-20 ${objMenu?.iconUrl} hamburger-menu-iconcolor flex-shrink-0`}></div>, route: objMenu?.menuUrl, guestMode: objMenu?.guestMode, sequenceNo: objMenu?.sequenceNo });
                    }
                }
            });
        } else { }

        arrMenus.sort((a, b) => {
            const orderA = objHamburgerMenu.items.findIndex(item => item.id === a.id);
            const orderB = objHamburgerMenu.items.findIndex(item => item.id === b.id);
            return orderA - orderB;
        });

        arrMenus.push(
            {
                id: 405, name: "Market Status", guestMode: 0,
                icon: <div className={'icon-20 icon-status hamburger-menu-iconcolor flex-shrink-0'}></div>
            },
            {
                id: 312, name: 'Settings', guestMode: 0, sequenceNo: 20,
                icon: <div className={'icon-20 icon-settings hamburger-menu-iconcolor flex-shrink-0'}></div>,
                route: "/setting"
            }
        );

        return arrMenus;
    }, [objHamburgerMenu, objCFT]);

    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - End

    // const handlePledgeUnpledgeRedirect = () => {
    //     let baseUrl = getAppInfoData(APP_INFO_PARAMS.APP_NETNET_PG_URL, appInfo);
    //     let urlForPledgeUnpledge = _generateUrlForPledgeUnpledge(baseUrl);
    //     const pledgeUnpledgeWindow = window.open(urlForPledgeUnpledge);
    // };

    // const replaceSpacesWithUnderScores = (str) => {
    //     return str?.replace(/\s/g, '_');
    // };

    // BT-115936 : Vinit Raut : 06-11-2023 : Breeze- Hamburger Menu- Exchange Links - Start
    const handleDashMenu = useCallback((each) => {
        localStorage.setItem(LOCAL_STORAGE_KEYS.PREVIOUS_SCREEN, pathname);//Ameersha N -- Saving previous screen in local storage in case user want to go back from present page to previous screen
        // Shuaib P. : 07-04-2023 : Common Function for global search and dash menu - Start
        hamburgerRoutes(each, navigate);
        dispatch(closeHamburgerMenu());
        // Shuaib P. : 07-04-2023 : Common Function for global search and dash menu - End
    }, [navigate, dispatch]);
    // BT-115936 : Vinit Raut : 06-11-2023 : Breeze- Hamburger Menu- Exchange Links - End

    const [focusCard, setFocusCard] = useState(arrDashMenu[0]?.id);


    const handleUpDown = useCallback((e) => {
        let key = e?.key
        let index = arrDashMenu?.findIndex(x => x.id === focusCard)
        if (key === "ArrowUp") {
            if (index === 0) {
                setFocusCard(arrDashMenu[0]?.id)
            } else {
                setFocusCard(arrDashMenu[index - 1]?.id)
            }
        }
        if (key === "ArrowDown") {
            if (index === arrDashMenu?.length - 1) {
                setFocusCard(arrDashMenu[index]?.id)
            } else {
                setFocusCard(arrDashMenu[index + 1]?.id)
            }
        }
        if (key === "Enter") {
            handleDashMenu(arrDashMenu[index])
        }

    }, [arrDashMenu, focusCard]);
    useEffect(() => {
        return () => dispatch(closeHamburgerMenu());
    }, [dispatch]);

    const logoutHandler = useCallback(() => {
        dispatch(handleModal([{ 'USER_LOG_OUT_CONFIRMATION_MODAL': true }])); // Hari k:12-09-2023 showing logout confirmation modal
    }, [dispatch]);

    useEffect(() => {
        document.addEventListener('keydown', handleUpDown)
        return () => {
            document.removeEventListener('keydown', handleUpDown)
        }
    }, [handleUpDown])

    return (

        <div className='hamburger-menu-wrap'>
            <div className='hamburger-menu'>
                <Container fluid className='p-0'>
                    <div className='hamburger-header bdr-btm'>
                        <Container fluid className='p-0 px-3 py-1'>
                            <Row className='g-0 w-100'>
                                <Col md={10} className='d-flex justify-content-start align-items-center'>
                                    <div className='logo-container'>
                                        <div className='logo img-fluid'></div>
                                    </div>
                                </Col>
                                <Col md={2} className='d-flex justify-content-end align-items-center'>
                                    <div className='icon-20 icon-close icon-dark flex-shrink-0' onClick={() => dispatch(closeHamburgerMenu())}></div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <div className='hamburger-content'>
                        <Container fluid className='p-0 px-2'>
                            {arrDashMenu.map((each) => (
                                <Row className={`g-0 my-2 hamburger-item ${focusCard === each.id ? 'active' : ''}`} key={each.id} onClick={() => { handleDashMenu(each); }}>
                                    <Col md={1} className='d-flex justify-content-start align-items-center'>
                                        {each.icon}
                                    </Col>
                                    <Col md={10} className='d-flex justify-content-start align-items-center'>
                                        <div className='font-medium font-size3 hamburger-menu-textcolor ms-2'>{each.name}</div>
                                    </Col>
                                    <Col md={1} className='d-flex justify-content-end align-items-center'>
                                        <div className='icon-12 icon-arrowright icon-dark flex-shrink-0'></div>
                                    </Col>
                                </Row>
                            ))
                            }
                        </Container>
                    </div>
                    <div className='hamburger-footer bdr-top'>
                        <Container fluid className='p-0 px-2 py-1'>
                            <Row className='g-0 hamburger-item' onClick={logoutHandler}>
                                <Col md={12} className='d-flex justify-content-start align-items-center gap-2'>
                                    <div className='icon-20 icon-logout icon-dark flex-shrink-0'></div>
                                    <div className='font-medium font-size3 hamburger-menu-textcolor line-height-1'>Logout</div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </Container>
            </div>
        </div>
    );
};

export default memo(DashMenu);
